/* global gtag, fbq, qp, _pcq, pushcrew */

import CURRENT_USER from './current-user';

export function getMetaContent(name) {
    return (document.querySelector(`meta[name="${name}"]`) || {}).content;
}

export const FRONT_END_URL = getMetaContent('upnest-front-end-url');
export const IMAGE_URL = getMetaContent('upnest-image-base-url') + 'img/';

export const IS_PRODUCTION =
    (value => value != 'false' && value != 0)(getMetaContent('upnest:is-production'));

export const BUILD_NUMBER = getMetaContent('upnest:build');
export const BUILD_BRANCH = getMetaContent('upnest:build-branch');
export const BUILD_DATE = getMetaContent('upnest:build-date');
export const BUILD_VERSION = getMetaContent('upnest:build-version') || '0.0.0';

export const GOOGLE_GEOCODING_KEY = getMetaContent('upnest:google-geocoding-key');

export const SUPPORT_EMAIL = getMetaContent('upnest:support-email');
export const SUPPORT_PHONE = getMetaContent('upnest:support-phone');

export const GOOGLE_GA4_KEY = getMetaContent('upnest:google-ga4-key');

export const USERBACK_KEY = getMetaContent('upnest:userback-key') || "";

export const WHITELABEL_BRAND = getMetaContent('upnest:whitelabel-brand');
export const WHITELABEL_COMPANY_NAME = getMetaContent('upnest:whitelabel-company-name') || 'UpNest';
export const BRAND_NAME = getMetaContent('upnest:brand-name') || 'UpNest';
export const WHITELABEL_SLUG = getMetaContent('upnest:whitelabel-slug') || null;
export const WHITELABEL_IMAGE_URL = getMetaContent('upnest:whitelabel-cdn-url');

export const TIME_TO_DISABLE_CALLNOW_BUTTON= getMetaContent('upnest:time-to-disable-callnow-button');
export const USER_LOCATION = getMetaContent('upnest:user-location');
export const MAX_FILE_UPLOAD_SIZE = getMetaContent('upnest:maxFileUploadSize');
export const SUBLINE_A = getMetaContent('upnest:subline-a');
export const SUBLINE_B = getMetaContent('upnest:subline-b');
export const REALTOR_AGENT_OR_BROKER = getMetaContent('upnest:agent-or-broker');
export const AB_TEST_ID_LIST = getMetaContent('ab-test-id-list');
export const ZIP_CODE = getMetaContent('zipcode');
export const USER_IP = getMetaContent('upnest:user-ip') || '';
export const USER_ID = getMetaContent('upnest:user-id') || null;
export const TWITTER_TITLE = getMetaContent('twitter:title') || '';
export const SELLERS_TOTAL_SAVINGS = getMetaContent('upnest-total-savings') || '';

export const SELL_SEARCH_FLOWS = getMetaContent('upnest:sell-search-flows');

export const US_PHONE_AREA_CODES = [
    205, 251, 256, 334, 659, 938, 907, 236, 250, 778, 480, 520, 602, 623, 928, 327, 479, 501,
    870, 209, 213, 279, 310, 323, 341, 408, 415, 424, 442, 510, 530, 559, 562, 619, 626, 628,
    650, 657, 661, 669, 707, 714, 747, 760, 805, 818, 820, 831, 840, 858, 909, 916, 925, 949,
    951, 303, 719, 720, 970, 203, 475, 860, 959, 302, 202, 771, 239, 305, 321, 352, 386, 407,
    448, 561, 656, 689, 727, 754, 772, 786, 813, 850, 863, 904, 941, 954, 229, 404, 470, 478,
    678, 706, 762, 770, 912, 943, 808, 208, 986, 217, 224, 309, 312, 331, 447, 464, 618, 630,
    708, 730, 773, 779, 815, 847, 872, 219, 260, 317, 463, 574, 765, 812, 930, 319, 515, 563,
    641, 712, 316, 620, 785, 913, 270, 364, 502, 606, 859, 225, 318, 337, 504, 985, 207, 227,
    240, 301, 410, 443, 667, 339, 351, 413, 508, 617, 774, 781, 857, 978, 231, 248, 269, 313,
    517, 586, 616, 679, 734, 810, 906, 947, 989, 218, 320, 507, 612, 651, 763, 952, 228, 601,
    662, 769, 314, 417, 557, 573, 636, 660, 816, 975, 406, 308, 402, 531, 702, 725, 775, 603,
    201, 551, 609, 640, 732, 848, 856, 862, 908, 973, 505, 575, 212, 315, 332, 347, 516, 518,
    585, 607, 631, 646, 680, 716, 718, 838, 845, 914, 917, 929, 934, 252, 336, 704, 743, 828,
    910, 919, 980, 984, 701, 216, 220, 234, 283, 326, 330, 380, 419, 440, 513, 567, 614, 740,
    937, 405, 539, 572, 580, 918, 458, 503, 541, 971, 215, 223, 267, 272, 412, 445, 484, 570,
    582, 610, 717, 724, 814, 878, 401, 803, 839, 843, 854, 864, 605, 423, 615, 629, 731, 865,
    901, 931, 210, 214, 254, 281, 325, 346, 361, 409, 430, 432, 469, 512, 682, 713, 726, 737,
    806, 817, 830, 832, 903, 915, 936, 940, 945, 956, 972, 979, 385, 435, 801, 802, 276, 434,
    540, 571, 703, 757, 804, 826, 948, 206, 253, 360, 425, 509, 564, 304, 681, 262, 274, 414,
    534, 608, 715, 920, 307
];

export const IS_ALSOBUYING_FLOW_AVAILABLE = (value => value != 'false' && value != 0)(getMetaContent('upnest:is-alsobuying-flow-available'));
export const IS_SALESFORCE_INVOICE_ENABLED = getMetaContent('upnest:isSalesforceInvoiceEnabled');
export const SALESFORCE_PAYMENT_URL = getMetaContent('upnest:salesforcePaymentUrl').replace(/\\\//g, "/");

// export const UPNEST_SELL_REFERRAL_FEE = 30;
export const UPNEST_BUY_REFERRAL_FEE = 30;

export const BLOG_CONSUMER_URL = getMetaContent('upnest:blog-consumer-url');
export const BLOG_KNOWLEDGE_BASE_URL = getMetaContent('upnest:blog-knowledge-base-url');

export const MIN_ALLOWED_COMM_FEE_PERCENTAGE_BUY = parseFloat(getMetaContent('upnest:min-allowed-comm-fee-percentage-buy') || 0);
export const MAX_ALLOWED_COMM_FEE_PERCENTAGE_BUY = parseFloat(getMetaContent('upnest:max-allowed-comm-fee-percentage-buy') || 100);
export const MIN_ALLOWED_COMM_FEE_PERCENTAGE_SELL = parseFloat(getMetaContent('upnest:min-allowed-comm-fee-percentage-sell') || 0);
export const MAX_ALLOWED_COMM_FEE_PERCENTAGE_SELL = parseFloat(getMetaContent('upnest:max-allowed-comm-fee-percentage-sell') || 100);

//Jepsen feature flags
export const JEPSEN_NON_LTK_BUY_SIDE_ENABLED = getMetaContent('upnest:jepsenBuySideEnabled') === 'true';
export const JEPSEN_NON_LTK_SELL_SIDE_ENABLED = getMetaContent('upnest:jepsenSellSideEnabled') === 'true';
export const JEPSEN_LTK_BUY_SIDE_ENABLED = getMetaContent('upnest:jepsenLtkBuySideEnabled') === 'true';
export const JEPSEN_LTK_SELL_SIDE_ENABLED = getMetaContent('upnest:jepsenLtkSellSideEnabled') === 'true';


export class CancelToken {
    onCancel;

    cancel() {
        this.onCancel && this.onCancel();
    }
}

class CancelError extends Error {
    constructor() {
        super('Canceled');
    }
}

export function isCanceled(error) {
    return error instanceof CancelError;
}

export function isBlank(str) {
    return !str || /^\s*$/.test(str);
}

export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return decodeURIComponent(parts.pop().split(';').shift().replace(/\+/g, '%20'));
    }
}

export function isSuperUser() {
    return getCookie('SUPERUSER') == 'true';
}

export function isSuperManager() {
    return getCookie('SUPERMANAGER') == 'true';
}

export function isSuperAdmin() {
    return getCookie('SUPER_ADMIN') == 'true';
}

export function delay(ms) {
    let ctr, rej, p = new Promise((resolve, reject) => {
        ctr = setTimeout(resolve, ms);
        rej = reject;
    });
    p.cancel = () => {
        clearTimeout(ctr);
        rej(Error("Cancelled"));
    };
    return p;
}

export function getCurrentPage() {
    const location = window.location;
    return location.protocol + '//' +
        location.host + location.pathname +
        (location.search ? location.search : "")
}

export function splitArray(array, predicate) {
    return array.reduce(([pass, fail], elem) => {
        return predicate(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    }, [[], []]);
}

export function throttleByPromise(handler) {
    let isInProgress = false;
    return function() {
        if (isInProgress) {
            return;
        }
        isInProgress = true;
        const result = handler();
        if (result) {
            if (typeof result.always === 'function') {
                result.always(function() {
                    isInProgress = false;
                });
            } else if (typeof result.finally === 'function') {
                result.finally(function() {
                    isInProgress = false;
                });
            } else {
                isInProgress = false;
            }
        } else {
            isInProgress = false;
        }
    };
}

export function ajaxGetJSON(options, params) {
    let url;
    if (typeof options == 'string') {
        url = options;
        options = {};
    } else {
        url = options.url;
    }

    if (options.cache != null && !options.cache) {
        // Prevent caching of response data by appending a timestamp to the URL. This works similarly to jQuery's
        // "cache" parameter in ajax(): https://api.jquery.com/jquery.ajax/
        url += (url.indexOf('?') === -1 ? '?' : '&') + '_=' + (new Date()).getTime();
    }

    if (params) {
        const searchParams = new URLSearchParams();
        Object.entries(params).filter(([k, v]) => v !== null && typeof v !== 'undefined').forEach(([k, v]) => {
            if (Array.isArray(v)) {
                v.forEach(value => {
                    searchParams.set(k, value + '');
                });
            } else {
                    searchParams.set(k, v + '');
            }
        });
        url += url.indexOf('?') === -1 ? '?' : '&';
        url += searchParams;
    }

    let abortController;
    let canceled = false;
    if (options.cancelToken instanceof CancelToken) {
        if (window.AbortController) {
            abortController = new AbortController();
            options.cancelToken.onCancel = () => {
                abortController.abort();
            };
        } else {
            options.cancelToken.onCancel = () => {
                canceled = true;
            };
        }
    }

    return fetch(FRONT_END_URL + url, {
        credentials: 'include',
        signal: abortController?.signal
    }).then(response => {
        if (response.status === 401) {
            window.location = FRONT_END_URL + 'login?nextRedirectUrl=' + encodeURIComponent(window.location.href);
        }
        return response.json();
    }).then(result => {
        if (canceled) {
            throw new CancelError();
        }
        return result;
    });
}

export function ajaxPost(url, params) {
    let formBody;
    let extraHeaders;

    if (params instanceof FormData) {
        formBody = params;
    } else if (typeof params == 'string') {
        formBody = params;
        extraHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        };
    } else if (params) {
        if (typeof params != 'object') {
            throw new Error('Expected an object');
        }
        formBody = new URLSearchParams(Object.entries(params || {}).filter(([, value]) => value != null));
    }

    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: extraHeaders,
        body: formBody
    });
}

export function ajaxPostJSON(url, params) {
    return ajaxPost(url, params).then(response => {
        if (response.status === 401) {
            window.location = FRONT_END_URL + 'login?nextRedirectUrl=' + encodeURIComponent(window.location.href);
        }
        return response.json();
    });
}

export function ajaxPostWithProgress(url, formData, onProgress) {
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.withCredentials = true;
        request.responseType = 'text';
        request.addEventListener('load', () => {
            if (request.status == 401) {
                window.location = FRONT_END_URL + 'login?nextRedirectUrl=' + encodeURIComponent(window.location.href);
                reject(new Error('Please log in to continue'));
                return;
            }
            let response = request.response;
            if (/^application\/json/i.test(request.getResponseHeader('Content-Type'))) {
                try {
                    response = JSON.parse(request.response);
                } catch (e) {
                    reject(e);
                    return;
                }
            }
            resolve(response);
        });
        request.addEventListener('error', event => {
            reject(new Error(event), event);
        });
        request.addEventListener('cancel', event => {
            reject(new Error('Cancelled'), event);
        });
        request.upload.addEventListener('progress', onProgress);
        request.open('POST', url);
        request.send(formData);
    });
}

export function checkAjax(data, quiet) {
    if (data && data.redirectUrl && !quiet) {
        let url = data.redirectUrl;
        if (data.msg) {
            url += (data.redirectUrl.indexOf('?') === -1 ? '?' : '&');
            url += 'msg=' + encodeURIComponent(data.msg);
        }
        window.location = url;
        return false;
    }
    if (data && data.msg) {
        if (!quiet) {
            showErrorModal(data.msg);
        }
        return false;
    }
    return true;
}

export function smallConfirm(text) {
    window.smallConfirmPopup.setState({text, shown: true}, () => {
        setTimeout(() => {
            window.smallConfirmPopup.close();
        }, 5000);
    });
}

export function showErrorModal(error) {
    const message = typeof error == 'string' ? error : error.message;
    window.globalErrorModal.setState({
        text: message || 'Sorry, there was an error.<br/>Please try again or contact our chat support.',
        shown: true
    });
}

export const showMessageModal = showErrorModal;

export function trackEvent(eventCategory, eventAction, eventLabel, data) {
    if (!IS_PRODUCTION) {
        console.log('Event: [category] ' + eventCategory
            + ' [action] ' + eventAction
            + ' [label] ' + eventLabel
            + ' [data] ' + JSON.stringify(data));
    }

    const params = {
        lastEvent: eventLabel || eventAction,
        userType: CURRENT_USER.getUserRole(),
        platform: 'Website'
    };
    if (data) {
        for (const key in data) {
            params[key] = data[key];
        }
    }
    const rdcVisitorId = getCookie('RDC_VISITOR_ID');
    if (rdcVisitorId) {
        params.rdc_visitor_id = rdcVisitorId;
    }
    mixpanel.track(eventLabel || eventAction, params);
    mixpanel.people.set(params);

    if (window.gtag) {
        let g4aEvents;
        if (!isSuperUser()) {
            g4aEvents = {send_to: GOOGLE_GA4_KEY, ...data};
        }
        gtag('event', eventLabel || eventAction, g4aEvents);
    }

    return {
        withOptimizely: function() {
            window.optimizely.push(["trackEvent", eventLabel || eventAction]);
            return this;
        },
        withGA: function(fields) {
            let fieldsData = fields || {};
            if (data) {
                fieldsData = {...fieldsData, ...data};
            }
            if (rdcVisitorId) {
                fieldsData['dimension1'] = rdcVisitorId;
            }
            ga('send', 'event', eventCategory, eventAction, eventLabel, fieldsData);
            return this;
        }
    };
}

export function trackSellRequestConversion(requestData, phonelessConversionPct) {
    if (!requestData) {
        return;
    }

    var requestUser = ((requestData ||{}).user || {});
    var isSuperUser = requestUser.admin || requestUser.manager || requestUser.userAgent;

    var estimate;
    if (requestData.zestimate) {
        estimate = requestData.zestimate;
    } else if (!requestData.lowRange) {
        estimate = requestData.highRange;
    } else {
        estimate = (+requestData.lowRange + +requestData.highRange) / 2 || 0;
    }
    var expectedRevenue = requestData.expectedRevenue;

	window.ec_email = (requestData.user || {}).email
	window.ec_phone = '+1' + (requestData.user || {}).phone
	gtag('set', 'user_data', {email: window.ec_email, phone_number: window.ec_phone});

	if (!IS_PRODUCTION
		|| isSuperUser
		|| (requestData.zestimate > 0 && requestData.zestimate < 50000)
		|| requestData.lowGreenAgentsCount
	) {
		// "beta" adwords
		var conversionValue;
			conversionValue = (estimate / 1000).toFixed(2);
		gtag('event', 'conversion', {
			send_to: 'AW-1026073853/Xz5sCLbN2_8CEP3JoukD',
			transaction_id: requestData.requestId,
			value: conversionValue,
			currency: 'USD'
		});
		console.log('Conversion value: ' + conversionValue);
		return;
	}

    // Bing
    (window.uetq = window.uetq || []).push({
        ea: 'sellerRequestConversion',
        gv: expectedRevenue
    });

	// AdWords Conversion: Sell Request
	gtag('event', 'conversion_request', {
		value: (estimate / 1000).toFixed(2),
		currency: 'USD',
		transaction_id: requestData.requestId,
	});

	// AdWords Sell Expected Revenue conversion
	gtag('event', 'conversion_revenue', {
		value: expectedRevenue,
		currency: 'USD',
        ord: requestData.requestId,
        transaction_id: requestData.requestId,
	});

    // Optimizely (is it still needed?)
    window.optimizely.push(['trackEvent', 'sellerRequestConversion']);

    // Twitter Pixel
    ((txnId, saleAmount) => {
        const script1 = document.createElement('script');
        script1.type = 'text/javascript';
        script1.src = 'https://platform.twitter.com/oct.js';
        document.head.appendChild(script1);
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.src = `window.twttr && window.twttr.conversion.trackPid(${txnId}, {tw_sale_amount: ${saleAmount}, tw_order_quantity: 1});`;
        document.head.appendChild(script2);
    })('ny0y6', Math.round(estimate));

    // Facebook Conversion Tracking Pixel
    fbq('track', 'CompleteRegistration', {
        value: estimate,
        currency: 'USD'
    });
    fbq('track', 'Purchase', {
        value: expectedRevenue,
        currency: 'USD'
    });

    // Quora Pixel
    window.qp && qp('track', 'CompleteRegistration');

    // GDN Pixel
    gtag('event', 'conversion', {
        send_to: 'AW-434760111/8363CNORsPMBEK_Tp88B',
        transaction_id: requestData.requestId,
        value: expectedRevenue,
        currency: 'USD'
    });

    // Everflow Pixel
    (transactionId => {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.krishetrk.com/?nid=397&oid=218&transaction_id=${transactionId}`;
        iframe.scrolling = 'no';
        iframe.frameBorder = '0';
        iframe.width = '1';
        iframe.height = '1';
        document.head.appendChild(iframe);
    })(requestData.requestId);
}

export function trackBuyRequestConversion(requestData, phonelessConversionPct) {
    if (!requestData) {
        return;
    }

    var isPhonelessRequest = requestData.submittedWithoutPhone;
    var requestUser = ((requestData ||{}).user || {});
    var isSuperUser = requestUser.admin || requestUser.manager || requestUser.userAgent;

    var estimate;
    if (!requestData.lowRange) {
        estimate = requestData.highRange;
    } else {
        estimate = (+requestData.lowRange + +requestData.highRange) / 2 || 0;
    }
    var phonelessEstimate = estimate * phonelessConversionPct;

    window.ec_email = (requestData.user || {}).email
	window.ec_phone = '+1' + (requestData.user || {}).phone
	gtag('set', 'user_data', {email: window.ec_email, phone_number: window.ec_phone});

    if (!IS_PRODUCTION || isSuperUser) {
        // "beta" adwords
        // do we need this for buy requests?
        var conversionValue;
        if (isPhonelessRequest) {
            conversionValue = Math.round(phonelessEstimate / 1000);
            gtag('event', 'conversion', {
                send_to: 'AW-1026073853/hvtWCIPIxoIDEP3JoukD',
                transaction_id: requestData.requestId,
                value: conversionValue,
                currency: 'USD',
            });
        } else {
            conversionValue = Math.round(estimate / 1000);
            gtag('event', 'conversion', {
                send_to: 'AW-1026073853/Xz5sCLbN2_8CEP3JoukD',
                transaction_id: requestData.requestId,
                value: conversionValue,
                currency: 'USD'
            });
        }
        console.log('Conversion value: ' + conversionValue);
        return;
    }

    var now = new Date();
    trackEvent('Flow', 'Request', 'buyRequestCreated', {
        convertedTime: now.getHours() + '' + now.getMinutes()
    }).withGA(Math.round((isPhonelessRequest ? phonelessEstimate : estimate) / 1000));

    // Advida tracking pixel
    // $('body').append(
    //     '<iframe src="https://www.krishetrk.com/?nid=397&oid=218&transaction_id={sub3}" scrolling="no" frameborder="0" width="1" height="1"></iframe>'
    // );

    // AdWords Conversion: Buy Request
    gtag('event', 'conversion_buy_request', {
        value: (estimate / 1000).toFixed(2),
        currency: 'USD',
        transaction_id: requestData.requestId,
        ord: requestData.requestId,
    });
}

export function replaceImageOnError(element, fallbackImgPath) {
    element.onerror = null;
    element.src = `${FRONT_END_URL}${fallbackImgPath}?v=${BUILD_NUMBER}`;
}

function isMobileBrowser() {
    let check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export function initUserFeedbackWidget() {
    if (!USERBACK_KEY){
    return;
    }
    window.Userback = window.Userback || {};
    window.Userback.access_token = USERBACK_KEY;
    (function(id) {
        var s = document.createElement('script');
        s.async = 1;
        s.src = 'https://static.userback.io/widget/v1.js';
        var parent_node = document.head || document.body;
        parent_node.appendChild(s);
    })('userback-sdk');
}

function onPushCrewSuccess(userId, currentSubscriberId, subscriberId) {
    console.log('[pushcrew] Subscriber ID:', subscriberId);
    if (subscriberId != null && subscriberId != currentSubscriberId) {
        ajaxPostJSON('recordSubscriberId', {
            userId: userId,
            subscribeId: subscriberId
        });
    }
}

function onPushCrewFailure(values) {
    console.log('[pushcrew] Failed to initialize PushCrew:', values.reasons);
}

export function initPushNotifications(userId, currentSubscriberId) {
    if (!isMobileBrowser()) {
        if (!userId) {
            return;
        }

        (function(p, u, s, h) {
            p._pcq = p._pcq || [];
            p._pcq.push(['_currentTime', Date.now()]);
            s = u.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://cdn.pushcrew.com/js/c27a33ef5701346b588d0b13c5679579.js';
            h = u.getElementsByTagName('script')[0];
            h.parentNode.insertBefore(s, h);
        })(window, document);
        window._pcq = window._pcq || [];

        _pcq.push(['APIReady', function() {
            onPushCrewSuccess(userId, currentSubscriberId, pushcrew.subscriberId);
        }, onPushCrewFailure]);
        _pcq.push(['subscriptionSuccessCallback', onPushCrewFailure]);
        _pcq.push(['subscriptionFailureCallback', onPushCrewFailure]);
        _pcq.push(['triggerOptIn', {subscriberSegment: 'homepage'}]);
    }
}

export const logEvent = (function() {
    const loggedEvents = new Set();

    const defaultParams = {
        clientsOnly: true,
        onlyOnce: true
    };

    return function logEvent(event) {
        if (CURRENT_USER.isAdmin() || CURRENT_USER.isSuperUser() || (event.clientsOnly && CURRENT_USER.isAgent())) {
            return;
        }
        if (!event.requestId && !event.realtorId) {
            console.log('[logEvent] Error: Either realtorId or requestId parameter must be present');
            return;
        }
        const requestType = event.isBuyer != null ? (event.isBuyer ? 'BUY' : 'SELL') : event.requestType;
        if (event.requestId && !requestType) {
            console.log('[logEvent] Error: Request type was not specified');
            return;
        }

        const onlyOnce = event.onlyOnce || defaultParams.onlyOnce;
        const hash =
            [event.event, event.requestId, event.requestType, event.realtorId, CURRENT_USER.getUserId()].join(';');
        if (onlyOnce && loggedEvents.has(hash)) {
            return;
        } else {
            loggedEvents.add(hash);
        }

        const data = {...defaultParams,
            eventType: event.event,
            requestType: requestType,
            requestId: event.requestId,
            realtorId: event.realtorId,
            comment: event.comment,
            onlyOnce: event.onlyOnce,
            clientsOnly: event.clientsOnly
        };
        if (event.attributes) {
            for (const attribute in event.attributes) {
                data["attributes." + attribute] = event.attributes[attribute];
            }
        }
        ajaxPostJSON('logEvent-json', data).then(function(data) {
            if (data.msg) {
                console.log('[logEvent] Error: ' + data.msg);
            }
        });
    }
})();

export function removeBlankOrNullValues(data) {
    let filteredData = {...data};
    Object.keys(filteredData).forEach(key => (filteredData[key] == null  || filteredData[key]?.length <= 0) && delete filteredData[key]);
    return filteredData;
}

export function getWhiteLabeledImageUrl(imagePath = '') {
    if (!!WHITELABEL_SLUG) {
        return `${WHITELABEL_IMAGE_URL}img/${imagePath}`;
    }
    return IMAGE_URL + imagePath;
}

export function getStaticResourceLink() {
    if (!!WHITELABEL_SLUG) {
        return `css/${WHITELABEL_SLUG}`;
    }
    return 'css';
}
